'use strict';

export default class BaseVO {
    protected valueOrDefault(propertyName: any, data?: Record<string, any>, defaultValue?: any): any {
        return data && data[propertyName] ? data[propertyName] : defaultValue ?? null;
    }
}
